import React, { useState } from "react";
import CoreHttpHandler from "../http/services/CoreHttpHandler";
import {
	ToastAlertSuccess,
	ToastAlertError,
	LoadingButton,
} from "../reauseble";
import { ToastContainer } from "react-toastify";
import loginImg from "../assets/images/register-login.png"
import PageHeader from "../pages/components/PagesHeaderComponent/PageHeader";
import { Input } from "antd";
import { Button } from "react-bootstrap";
import { Box, LinearProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
const Forgotpassword = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [email, setEmail] = useState("");
	const [token, setToken] = useState("");
	const handleSendPassword = (e) => {
		if (email) {
			setLoading(true);
			e.preventDefault();
			CoreHttpHandler.request(
				"forms",
				"sendEmail",
				{
					email: email,
				},
				(response) => {
					const res = response?.data?.data?.forgotPassword?.message;
					setLoading(false);
					setEmail("");
					if (res === "Email not found.") {
						ToastAlertError(res);

					} else {
						ToastAlertSuccess(res || "Password successfully sent to your Email");
						navigate("/");
					}
				},
				(err) => {
					setLoading(false);

					ToastAlertError(
						err?.response?.data?.message
							? err?.response.data.message
							: "something went wrong"
					);
				}
			);
		} else {
			ToastAlertError("Email Required!");
		}
	};

	return (
		<>
			<PageHeader heading={"Recover Password"} />
			<section className='main_form forgot_sec'>
				{/* <canvas></canvas> */}
				<div className='container flex_btw'>
					<div className="login_img">
						<img src={loginImg} />
					</div>

					<div className='inner_sec'>
						<div className="inputs forgotInp">

							<h2>Recover Your Password</h2>
							{loading ?
								<Box sx={{ my: '5rem' }}>
									<LinearProgress color="success" />
								</Box>
								:
								<>
									<Input style={{ border: "1px solid lightgrey" }} placeholder="Email" value={email}
										required
										onChange={(e) =>
											setEmail(e.target.value)
										} />
									<Button onClick={handleSendPassword} className="forgot_btn" variant="primary">Send Password</Button>
								</>
							}
						</div>


					</div>
				</div>
			</section>
		</>
	);
};

export default Forgotpassword;
